// Typelizer digest 3e2f1a3d4f7b2fdbf764713170707b14
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /admin/productions/:production_id/characters/:id */
  update: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/admin/productions/:production_id/characters/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /admin/productions/:production_id/characters/:id */
  destroy: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/admin/productions/:production_id/characters/:id', params, options),
    method: 'delete',
  }),
}
